module.exports = __webpack_public_path__ + "img/cloud.373fc46c.jpg";